import {Accordion as MuiAccordion, Box, styled, Typography} from "@mui/material"
import React, {useState} from "react"
import {checkVisibility} from "../../misc/precondition-evaluation"
import Content from "../../components/Content"
import AccordionBase from "./accordion/AccordionBase"

export const containerAccordionGroupPrototype = [
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {value: "DEFAULT", label: "Default"},
            {value: "OUTLINED", label: "Outlined"},
        ],
    },
    {
        key: "exclusive",
        type: "CHECKBOX",
        label: "Nur ein Panel gleichzeitig öffnen?",
        size: 6,
    },
]

const AccordionWrapper = styled(MuiAccordion, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => theme.ACCORDIONGROUP?.wrapper(theme, variant))

const AccordionTitle = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => theme.ACCORDIONGROUP?.title(theme, variant))

const AccordionSubtitle = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "variant",
})(({theme, variant}) => theme.ACCORDIONGROUP?.subtitle(theme, variant))

const ContainerAccordionGroup = ({container, getDataFromPointer}) => {
    const exclusive = container?.exclusive ?? true
    const [expandedIndices, setExpandedIndices] = useState(new Set())
    const variant = container?.variant ?? "DEFAULT"

    const handleChange = (index) => (_, isExpanded) => {
        if (exclusive) {
            setExpandedIndices(isExpanded ? new Set([index]) : new Set())
        } else {
            setExpandedIndices((previous) => {
                const next = new Set(previous)
                isExpanded ? next.add(index) : next.delete(index)
                return next
            })
        }
    }

    return (
        <Box>
            {container.children?.map((child, index) => {
                if (!checkVisibility(child, getDataFromPointer)) return null
                const isOpen = expandedIndices.has(index)
                return (
                    <AccordionBase
                        key={child.id}
                        Wrapper={AccordionWrapper}
                        Title={AccordionTitle}
                        Subtitle={AccordionSubtitle}
                        variant={variant}
                        expanded={isOpen}
                        onChange={handleChange(index)}
                        disableGutters
                        text={child.text}
                        subtext={child.subtext}
                        badge={child.badge}
                        infotext={child.infotext}>
                        <Content child={child} />
                    </AccordionBase>
                )
            })}
        </Box>
    )
}

export default ContainerAccordionGroup
